import Image from "next/image"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { NavigationItem } from "types/navigation"

export default function IconList({
  items,
  title,
}: {
  items: NavigationItem[]
  title?: string
}) {
  // Auto multi-column for many items
  const colCount =
    items.length > 16 ? 4 : items.length > 12 ? 3 : items.length > 8 ? 2 : 1
  const useGrid = colCount > 1

  return (
    <div>
      {title && (
        <h3 className="text-[13px] font-bold text-brand-navy uppercase tracking-wide mb-2 pb-1 border-b border-gray-200">
          {title}
        </h3>
      )}
      <ul
        className={
          useGrid
            ? `grid gap-x-4 gap-y-0`
            : "space-y-0"
        }
        style={useGrid ? { gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))` } : undefined}
      >
        {items.map((item) => (
          <li key={item.id}>
            <LocalizedClientLink
              href={item.url}
              className={`flex items-center gap-2.5 text-[13px] leading-tight py-1.5 transition-colors ${
                item.highlight
                  ? "text-brand-accent font-bold hover:text-red-700"
                  : "text-gray-700 hover:text-brand-primary font-medium"
              }`}
            >
              {item.icon_url && (
                <Image
                  src={item.icon_url}
                  alt=""
                  width={24}
                  height={24}
                  loading="lazy"
                  className="flex-shrink-0 w-6 h-6 object-contain"
                />
              )}
              <span>{item.label}</span>
            </LocalizedClientLink>
          </li>
        ))}
      </ul>
    </div>
  )
}
